import { baseApi } from '@ibk/shared-config';
export var TaxReportStatus;
(function (TaxReportStatus) {
    TaxReportStatus["GENERATED"] = "GENERATED";
    TaxReportStatus["IN_PROCESS"] = "IN_PROCESS";
    TaxReportStatus["ERROR"] = "ERROR";
})(TaxReportStatus || (TaxReportStatus = {}));
export const taxReportApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        generateTaxReport: builder.mutation({
            query: ({ accountId, year }) => ({
                url: `/v1/accounts/${accountId}/tax-report/${year}`,
                method: 'POST',
                body: {},
            }),
            transformResponse: (response) => {
                return response.result;
            },
            invalidatesTags: ['Base'],
        }),
    }),
    overrideExisting: false,
});
export const { useGenerateTaxReportMutation } = taxReportApi;
